"use strict";

(function (angular) {
  "use strict";

  angular.module("fleetviewApp").component("resetPassword", {
    template: require("./resetPassword.html"),
    controller: ResetPasswordController
  });

  ResetPasswordController.$inject = ["$location", "$filter", "alkAuthenticationService", "Messages", "ALKResetPassword"];

  function ResetPasswordController($location, $filter, alkAuthenticationService, Messages, ALKResetPassword) {
    var vm = this;

    vm.isProcessing = false;
    vm.userInfo = {};
    vm.redirectTo = "";
    vm.submitResetPassword = submitResetPassword;

    vm.$onInit = init;

    function init() {
      var searchObject = $location.search();

      vm.userInfo = {
        email: searchObject.email,
        token: searchObject.token,
        password: "",
        confirmPassword: ""
      };

      var redirectTo = "/";

      if ($location.search().r) {
        redirectTo = decodeURIComponent($location.search().r);
      }

      vm.redirectTo = redirectTo;
    }

    function submitResetPassword(isValid) {
      if (!isValid) return;

      vm.isProcessing = true;
      Messages.clear();

      var resetPassword = new ALKResetPassword(vm.userInfo.email, vm.userInfo.password, vm.userInfo.token);

      alkAuthenticationService.resetPassword(resetPassword).then(function () {
        return _handleSuccess();
      }, function (err) {
        return _handleError(err);
      }).finally(function () {
        return vm.isProcessing = false;
      });
    }

    function _handleError(err) {
      if (err.status === "TokenInvalid") {
        Messages.add("danger", $filter("translate")("views.resetPassword.ErrorInvalidToken"), {
          showOnNextPage: false
        });
      } else if (err.status === "LoginNotExist") {
        Messages.add("danger", $filter("translate")("views.resetPassword.ErrorLoginNotExist"), {
          showOnNextPage: false
        });
      } else {
        Messages.add("danger", $filter("translate")("views.resetPassword.Error"), {
          showOnNextPage: false
        });
      }
    }

    function _handleSuccess() {
      Messages.add("success", $filter("translate")("views.resetPassword.Success"), {
        showOnNextPage: true
      });
      $location.url(vm.redirectTo);
    }
  }
})(window.angular);


// WEBPACK FOOTER //
// ./app/auth/resetPassword.controller.js